import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs';
import { UserDataService } from 'src/app/core/services/user-data.service';
import { environment } from 'src/environments/environment';
import { CustomerPortal } from '../secured-skeleton/models/customer-portal';

@Component({
  selector: 'forbidden-access',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss'],
  standalone: false,
})
export class ForbiddenComponent implements OnInit {
  // Stores info about the portal trying to be accessed
  portal: CustomerPortal;

  // Stores the restricted submodule name, if access was denied at submodule level
  submoduleName: string | null = null;

  /// True while the component is loading the system administrators
  isLoadingSystemAdmins: boolean = false;

  /// The list of system admins
  systemAdmins: AdminContact[] = [];

  constructor(
    private router: Router,
    private http: HttpClient,
    private route: ActivatedRoute,
    private userDataService: UserDataService,
  ) {}

  ngOnInit() {
    this.fetchSystemAdmins();

    this.route.params.subscribe((params) => {
      this.portal = this.userDataService.portals.filter((portal) => portal.addonName === params['addon'])[0];
    });

    this.route.queryParams.subscribe((queryParams) => {
      this.submoduleName = queryParams['submodule'] ? decodeURIComponent(queryParams['submodule']) : null;
    });
  }

  returnToHomePage() {
    this.router.navigateByUrl('secured/home');
  }

  /// Retrieves the system administrators from the db
  private fetchSystemAdmins() {
    this.isLoadingSystemAdmins = true;
    const companyId = this.userDataService.company.id;
    this.http
      .get<AdminContact[]>(`${environment.restUrl}/v1/hub/companies/${companyId}/admins`)
      .pipe(finalize(() => (this.isLoadingSystemAdmins = false)))
      .subscribe((systemAdmins) => {
        this.systemAdmins = systemAdmins; //.filter((admin, index) => index < 3)
      });
  }
}

interface AdminContact {
  fullName: string;
  email: string;
}
